import { useState, useEffect } from 'react'
import useTranslation from 'next-translate/useTranslation'
import { apiPost } from 'tennders-stracture/libs/api'
import { GButton, GInput } from 'tennders-common/form/components'
import TSummary from 'tennders-transactions/modal/TSummary'
import GModal from 'tennders-market/common/components/element/GModal'
import { useToast } from 'tennders-common/hooks/useToast'
import { ModalProps } from 'tennders-common/types/ModalProps'
import { TransactionType } from 'tennders-transactions/types/TransactionType'
import usePopupStore from 'tennders-common/stores/usePopupStore'
import { INPUT_CHARACTER_LIMITS } from 'tennders-stracture/libs/constants'

const MSendCheckOffer = (props: ModalProps) => {
  const [checkOffer, show] = usePopupStore((state: Record<string, any>) => [state.checkOffer, state.show])
  const [transaction, settransaction] = useState<TransactionType>()
  const { t } = useTranslation()
  const { toastSuccess } = useToast()
  const [form, setform] = useState({
    email: '',
    subject: t('modal:checkThisOffer')
  })
  const [errors, seterrors] = useState({})
  const [submitting, setsubmitting] = useState(false)
  const close = () => show('checkOffer', null)
  const commonProps = {
    onChange: (k, v) => setform({ ...form, [k]: v }),
    form,
    errors
  }

  useEffect(() => {
    setform({ ...form })
    if (checkOffer) {
      settransaction(checkOffer.transaction)
    }
  }, [checkOffer])

  const send = async () => {
    setsubmitting(true)

    const response = await apiPost('transactions/send-check-offer', {
      ...form,
      transaction: transaction.id
    })
    if (response.errors) {
      seterrors(response.errors)
    }
    toastSuccess(t('modal:emailSent'))
    setsubmitting(false)
    close()
  }

  return (
    <GModal isOpen={!!checkOffer} close={close} size="80%" {...props}>

      <div className="tennders-modal-body w-100">

        <div className="d-flex">
          <TSummary t={t} transaction={transaction} />
          <div className="col-2 bg-color-light-gray">
            <div className="p-20 mt-40">

              <GInput
                label={t('modal:receipentMail')}
                name="email"
                maxLength={INPUT_CHARACTER_LIMITS.EMAIL}
                {...commonProps}
              />
              <GInput label={t('modal:subject')} eClass="mt-20" name="subject" {...commonProps} />

              <GButton
                disabled={!form.email || form.email.length === 0 || !form.subject || form.subject.length === 0}
                onClick={send}
                submitting={submitting}
                className="btn standard-btn cursor-pointer mt-20"
              >
                {t('modal:sendEmail')}
              </GButton>
            </div>
          </div>
        </div>

      </div>

    </GModal>
  )
}

export default MSendCheckOffer
